var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "section-wrapper" }, [
      _c("div", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 application-card-wrapper" }, [
            _c(
              "div",
              {
                staticClass: "card pb-0 application-card h-100",
                attrs: { id: "address" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header px-5",
                    attrs: { id: _vm._f("hashId")("property[address]") },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("h2", { staticClass: "section-separator-title" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$tc("application-form.address", 1)) +
                              "\n                  "
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-body px-5" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [_vm.visibilityPaths.address],
                            "size-class": "col-12",
                            title: _vm.editVisibility
                              ? _vm.$tc("application-form.address", 1)
                              : "",
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("address-section", {
                            attrs: {
                              "edit-visibility": _vm.editVisibility,
                              "show-labels": !_vm.editVisibility,
                              title: _vm.editVisibility
                                ? ""
                                : _vm.$t("application-form.property-address"),
                              path: _vm.visibilityPaths.address,
                              index: 0,
                              replicate: !_vm.editVisibility,
                              "replicate-text": _vm.$t(
                                "application-form.copy-current-address"
                              ),
                              "success-replicated-text":
                                "Copied from Current Address",
                              "max-length": "",
                              "google-maps": "",
                              tabindex: "100",
                            },
                            on: { replicate: _vm.handleReplicateAddress },
                            model: {
                              value: _vm.address,
                              callback: function ($$v) {
                                _vm.address = $$v
                              },
                              expression: "address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xl-12 col-12" }, [
            _c(
              "div",
              {
                staticClass: "card pb-0 application-card",
                attrs: { id: "mls-info" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header px-5",
                    attrs: { id: _vm._f("hashId")("property[mls-info]") },
                  },
                  [
                    _c("div", { staticClass: "row align-items-center" }, [
                      _c("div", { staticClass: "col-11" }, [
                        _c("h2", { staticClass: "section-separator-title" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("application-form.mls-information")
                              ) +
                              "\n                  "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.editVisibility
                        ? _c(
                            "div",
                            { staticClass: "col" },
                            [
                              _c("multiple-visibility-button", {
                                attrs: {
                                  "visibility-paths":
                                    _vm.PagesVisibilityMap["mls-information"],
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-body px-5" }, [
                  _c(
                    "div",
                    { staticClass: "row align-items-start" },
                    [
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.mlsListing,
                            ],
                            "size-class":
                              "col-lg-2 col-sm-auto col-12 radio-field",
                            title: _vm.$t("application-form.is-mls-listing"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("radio-section", {
                            attrs: {
                              name: "mls-listing",
                              options: _vm.basicBinaryOptions,
                              tabindex: "200",
                            },
                            model: {
                              value: _vm.mlsListing,
                              callback: function ($$v) {
                                _vm.mlsListing = $$v
                              },
                              expression: "mlsListing",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [_vm.visibilityPaths.lot],
                            "size-class": "col-sm-3 col-12",
                            title: _vm.$t("application-form.lot-name"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              name: "lot",
                              placeholder: "132E",
                              "max-length": "35",
                              tabindex: "200",
                              label: _vm.$t("application-form.lot-name"),
                            },
                            model: {
                              value: _vm.lot,
                              callback: function ($$v) {
                                _vm.lot = $$v
                              },
                              expression: "lot",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [_vm.visibilityPaths.block],
                            "size-class": "col-sm-3 col-12",
                            title: _vm.$t("application-form.block-name"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              name: "block",
                              placeholder:
                                _vm.$t("application-form.block") + " A",
                              "max-length": "35",
                              tabindex: "200",
                              label: _vm.$t("application-form.block-name"),
                            },
                            model: {
                              value: _vm.block,
                              callback: function ($$v) {
                                _vm.block = $$v
                              },
                              expression: "block",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.concTownship,
                            ],
                            "size-class": "col-sm-3 col-12",
                            title: _vm.$t("application-form.township"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              name: "conc-township",
                              placeholder: _vm.$t("application-form.king-city"),
                              "max-length": "35",
                              tabindex: "200",
                              label: _vm.$t("application-form.township"),
                            },
                            model: {
                              value: _vm.concTownship,
                              callback: function ($$v) {
                                _vm.concTownship = $$v
                              },
                              expression: "concTownship",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              {
                staticClass: "card pb-0 application-card",
                attrs: { id: "property-details" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header px-5",
                    attrs: { id: _vm._f("hashId")("property[details]") },
                  },
                  [
                    _c("div", { staticClass: "row align-items-center" }, [
                      _c("div", { staticClass: "col-11" }, [
                        _c("h2", { staticClass: "section-separator-title" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("application-form.property-details")
                              ) +
                              "\n                  "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.editVisibility
                        ? _c(
                            "div",
                            { staticClass: "col" },
                            [
                              _c("multiple-visibility-button", {
                                attrs: {
                                  "visibility-paths":
                                    _vm.PagesVisibilityMap["property-details"],
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "card-body px-5",
                    attrs: { id: _vm._f("hashId")("property[styles]") },
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row align-items-start" },
                          [
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "row" },
                                [
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.purchaseDate,
                                        ],
                                        "size-class":
                                          "col-lg-4 col-sm-6 col-12",
                                        title: _vm.$t(
                                          "application-form.purchase-date"
                                        ),
                                        "container-class": "w-100",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          name: "purchase-date",
                                          placeholder: "YYYY-MM-DD",
                                          "class-name": "date-format",
                                          "icon-class": "purchase-date-icon",
                                          tabindex: "300",
                                          label: _vm.$t(
                                            "application-form.purchase-date"
                                          ),
                                        },
                                        on: { change: _vm.handleSave },
                                        model: {
                                          value: _vm.purchaseDate,
                                          callback: function ($$v) {
                                            _vm.purchaseDate = $$v
                                          },
                                          expression: "purchaseDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.livingSpace,
                                        ],
                                        "size-class":
                                          "col-lg-4 col-sm-6 col-12",
                                        title: _vm.$t(
                                          "application-form.property-size-sq-ft"
                                        ),
                                        "container-class": "w-100",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          name: "living-space",
                                          "class-name": "fe-num-field",
                                          tabindex: "300",
                                          label: _vm.$t(
                                            "application-form.property-size-sq-ft"
                                          ),
                                        },
                                        model: {
                                          value: _vm.livingSpace,
                                          callback: function ($$v) {
                                            _vm.livingSpace = $$v
                                          },
                                          expression: "livingSpace",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.propertyType,
                                  ],
                                  "size-class": "col-sm-4",
                                  title: _vm.$t(
                                    "application-form.property-type"
                                  ),
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("select-section", {
                                  attrs: {
                                    name: "property-type",
                                    options: _vm.propertyTypeOptions,
                                    tabindex: "300",
                                  },
                                  model: {
                                    value: _vm.propertyType,
                                    callback: function ($$v) {
                                      _vm.propertyType = $$v
                                    },
                                    expression: "propertyType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.lotSize,
                                  ],
                                  "size-class": "col-sm-4",
                                  title: _vm.$t("application-form.lot-size"),
                                  "container-class": "w-100",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    name: "lot-size",
                                    placeholder: "0",
                                    "class-name": "fe-num-field",
                                    tabindex: "300",
                                    label: _vm.$t("application-form.lot-size"),
                                  },
                                  model: {
                                    value: _vm.lotSize,
                                    callback: function ($$v) {
                                      _vm.lotSize = $$v
                                    },
                                    expression: "lotSize",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.lotSizeType,
                                  ],
                                  "size-class": "col-sm-4",
                                  title: _vm.$t(
                                    "application-form.unit-of-measurement"
                                  ),
                                  "container-class": "w-100",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("select-section", {
                                  attrs: {
                                    name: "lot-size-type",
                                    options: _vm.unitOfMeasurementOptions,
                                    tabindex: "300",
                                  },
                                  model: {
                                    value: _vm.lotSizeType,
                                    callback: function ($$v) {
                                      _vm.lotSizeType = $$v
                                    },
                                    expression: "lotSizeType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.constructionType,
                                  ],
                                  "size-class": "col-lg-4 col-sm-4 radio-field",
                                  title: _vm.$t(
                                    "application-form.construction-type"
                                  ),
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("radio-section", {
                                  attrs: {
                                    name: "construction-type",
                                    options: _vm.constructionTypeOptions,
                                    tabindex: "300",
                                  },
                                  model: {
                                    value: _vm.constructionType,
                                    callback: function ($$v) {
                                      _vm.constructionType = $$v
                                    },
                                    expression: "constructionType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.propertyStyle,
                                  ],
                                  "size-class": "col-lg-4 col-sm-4",
                                  title: _vm.$t(
                                    "application-form.property-style"
                                  ),
                                  "container-class": "w-100",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("select-section", {
                                  attrs: {
                                    name: "property-style",
                                    options: _vm.propertyStyleOptions,
                                    tabindex: "300",
                                  },
                                  model: {
                                    value: _vm.propertyStyle,
                                    callback: function ($$v) {
                                      _vm.propertyStyle = $$v
                                    },
                                    expression: "propertyStyle",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.numberOfUnits,
                                  ],
                                  "size-class": "col-lg-4 col-sm-4",
                                  title: _vm.$t(
                                    "application-form.number-of-units"
                                  ),
                                  "container-class": "w-100",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    name: "number-of-units",
                                    placeholder: "0",
                                    "class-name": "fe-num-field",
                                    tabindex: "300",
                                    label: _vm.$t(
                                      "application-form.number-of-units"
                                    ),
                                  },
                                  model: {
                                    value: _vm.numberOfUnits,
                                    callback: function ($$v) {
                                      _vm.numberOfUnits = $$v
                                    },
                                    expression: "numberOfUnits",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-lg-4 order-lg-1 order-2" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _c(
                                      "field",
                                      {
                                        attrs: {
                                          "edit-visibility": _vm.editVisibility,
                                          "visibility-paths": [
                                            _vm.visibilityPaths.structureAge,
                                          ],
                                          "size-class": "col-lg-12 col-md-6",
                                          title: _vm.$t(
                                            "application-form.structure-age-in-years"
                                          ),
                                          "container-class": "w-100",
                                        },
                                        on: {
                                          "toggle-visibility":
                                            _vm.handleVisibility,
                                        },
                                      },
                                      [
                                        _c("text-section", {
                                          attrs: {
                                            name: "structure-age",
                                            placeholder: "1",
                                            "class-name": "fe-num-field",
                                            tabindex: "300",
                                            label: _vm.$t(
                                              "application-form.structure-age-in-years"
                                            ),
                                          },
                                          model: {
                                            value: _vm.structureAge,
                                            callback: function ($$v) {
                                              _vm.structureAge = $$v
                                            },
                                            expression: "structureAge",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "field",
                                      {
                                        attrs: {
                                          "edit-visibility": _vm.editVisibility,
                                          "visibility-paths": [
                                            _vm.visibilityPaths.tenure,
                                          ],
                                          "size-class":
                                            "col-lg-12 col-md-6 radio-field",
                                          title: _vm.$t(
                                            "application-form.tenure"
                                          ),
                                        },
                                        on: {
                                          "toggle-visibility":
                                            _vm.handleVisibility,
                                        },
                                      },
                                      [
                                        _c("radio-section", {
                                          attrs: {
                                            name: "tenure",
                                            options: _vm.tenureOptions,
                                            "full-width": true,
                                            tabindex: "300",
                                          },
                                          model: {
                                            value: _vm.tenure,
                                            callback: function ($$v) {
                                              _vm.tenure = $$v
                                            },
                                            expression: "tenure",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-lg-8 order-lg-2 order-1" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _c(
                                      "field",
                                      {
                                        attrs: {
                                          "edit-visibility": _vm.editVisibility,
                                          "visibility-paths": [
                                            _vm.visibilityPaths.garageSize,
                                            _vm.visibilityPaths.garageStyle,
                                          ],
                                          "size-class": "col-sm-6",
                                          title: _vm.$t(
                                            "application-form.garage-size"
                                          ),
                                        },
                                        on: {
                                          "toggle-visibility":
                                            _vm.handleVisibility,
                                        },
                                      },
                                      [
                                        _c("select-section", {
                                          attrs: {
                                            name: "garage-size",
                                            options: _vm.garageSizeOptions,
                                            tabindex: "300",
                                          },
                                          model: {
                                            value: _vm.garageSize,
                                            callback: function ($$v) {
                                              _vm.garageSize = $$v
                                            },
                                            expression: "garageSize",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "transition",
                                      { attrs: { name: "slide-fade" } },
                                      [
                                        _vm.editVisibility ||
                                        _vm.visibilityToggle(
                                          _vm.currentApplication,
                                          _vm._visibilityDataContext,
                                          "['property']['styles']['garage-size']",
                                          _vm.garageSizeOptions,
                                          "garageStyle"
                                        )
                                          ? _c(
                                              "field",
                                              {
                                                attrs: {
                                                  "edit-visibility":
                                                    _vm.editVisibility,
                                                  "visibility-paths": [
                                                    _vm.visibilityPaths
                                                      .garageStyle,
                                                  ],
                                                  "depends-upon": [
                                                    _vm.visibilityPaths
                                                      .garageSize,
                                                  ],
                                                  "size-class":
                                                    "col-sm-6 radio-field",
                                                  title: _vm.$t(
                                                    "application-form.garage-style"
                                                  ),
                                                },
                                                on: {
                                                  "toggle-visibility":
                                                    _vm.handleVisibility,
                                                },
                                              },
                                              [
                                                _c("radio-section", {
                                                  attrs: {
                                                    name: "garage-style",
                                                    options:
                                                      _vm.garageStyleOptions,
                                                    tabindex: "300",
                                                  },
                                                  model: {
                                                    value: _vm.garageStyle,
                                                    callback: function ($$v) {
                                                      _vm.garageStyle = $$v
                                                    },
                                                    expression: "garageStyle",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "row",
                                    attrs: {
                                      id: _vm._f("hashId")(
                                        "property[environment-and-sewage]"
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "field",
                                      {
                                        attrs: {
                                          "edit-visibility": _vm.editVisibility,
                                          "visibility-paths": [
                                            _vm.visibilityPaths.sewageInfo,
                                          ],
                                          "size-class": "col-sm-6",
                                          title: _vm.$t(
                                            "application-form.sewage-type"
                                          ),
                                        },
                                        on: {
                                          "toggle-visibility":
                                            _vm.handleVisibility,
                                        },
                                      },
                                      [
                                        _c("select-section", {
                                          attrs: {
                                            name: "sewage-info",
                                            options: _vm.sewageTypeOptions,
                                            tabindex: "300",
                                          },
                                          model: {
                                            value: _vm.sewageInfo,
                                            callback: function ($$v) {
                                              _vm.sewageInfo = $$v
                                            },
                                            expression: "sewageInfo",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "field",
                                      {
                                        attrs: {
                                          "edit-visibility": _vm.editVisibility,
                                          "visibility-paths": [
                                            _vm.visibilityPaths
                                              .environmentalHazard,
                                          ],
                                          "size-class": "col-sm-6 radio-field",
                                          "long-title": true,
                                          title: _vm.$t(
                                            "application-form.is-environmental-hazard"
                                          ),
                                        },
                                        on: {
                                          "toggle-visibility":
                                            _vm.handleVisibility,
                                        },
                                      },
                                      [
                                        _c("radio-section", {
                                          attrs: {
                                            name: "environmental-hazard",
                                            options: _vm.basicBinaryOptions,
                                            tabindex: "300",
                                          },
                                          model: {
                                            value: _vm.environmentalHazard,
                                            callback: function ($$v) {
                                              _vm.environmentalHazard = $$v
                                            },
                                            expression: "environmentalHazard",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "row",
                                    attrs: {
                                      id: "property[water-and-heating]",
                                    },
                                  },
                                  [
                                    _c(
                                      "field",
                                      {
                                        attrs: {
                                          "edit-visibility": _vm.editVisibility,
                                          "visibility-paths": [
                                            _vm.visibilityPaths.heat,
                                          ],
                                          "size-class": "col-sm-6",
                                          title: _vm.$t(
                                            "application-form.heating-type"
                                          ),
                                        },
                                        on: {
                                          "toggle-visibility":
                                            _vm.handleVisibility,
                                        },
                                      },
                                      [
                                        _c("select-section", {
                                          attrs: {
                                            name: "heat",
                                            options: _vm.heatingTypeOptions,
                                            tabindex: "300",
                                          },
                                          model: {
                                            value: _vm.heat,
                                            callback: function ($$v) {
                                              _vm.heat = $$v
                                            },
                                            expression: "heat",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "field",
                                      {
                                        attrs: {
                                          "edit-visibility": _vm.editVisibility,
                                          "visibility-paths": [
                                            _vm.visibilityPaths.waterInfo,
                                          ],
                                          "size-class": "col-sm-6 radio-field",
                                          title: _vm.$t(
                                            "application-form.water-information"
                                          ),
                                        },
                                        on: {
                                          "toggle-visibility":
                                            _vm.handleVisibility,
                                        },
                                      },
                                      [
                                        _c("radio-section", {
                                          attrs: {
                                            name: "water-info",
                                            options: _vm.waterInfoOptions,
                                            tabindex: "300",
                                          },
                                          model: {
                                            value: _vm.waterInfo,
                                            callback: function ($$v) {
                                              _vm.waterInfo = $$v
                                            },
                                            expression: "waterInfo",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-xxl-6" }, [
            _c(
              "div",
              {
                staticClass: "card pb-0 application-card",
                attrs: { id: "property-taxes" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header px-5",
                    attrs: { id: _vm._f("hashId")("property[taxes]") },
                  },
                  [
                    _c("div", { staticClass: "row align-items-center" }, [
                      _c("div", { staticClass: "col-11" }, [
                        _c("h2", { staticClass: "section-separator-title" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("application-form.property-taxes")
                              ) +
                              "\n                  "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.editVisibility
                        ? _c(
                            "div",
                            { staticClass: "col" },
                            [
                              _c("multiple-visibility-button", {
                                attrs: {
                                  "visibility-paths":
                                    _vm.PagesVisibilityMap["property-taxes"],
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-body px-5" }, [
                  _c(
                    "div",
                    { staticClass: "row align-items-start" },
                    [
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [_vm.visibilityPaths.taxYear],
                            "size-class": "col-6",
                            title: _vm.$t(
                              "application-form.most-recent-tax-year"
                            ),
                            "container-class": "w-100",
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              name: "tax-year",
                              placeholder: "2019",
                              "class-name":
                                "fe-num-field fe-most-recent-tax-year",
                              tabindex: "400",
                              label: _vm.$t(
                                "application-form.most-recent-tax-year"
                              ),
                            },
                            model: {
                              value: _vm.taxYear,
                              callback: function ($$v) {
                                _vm.taxYear = $$v
                              },
                              expression: "taxYear",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.propertyTaxes,
                            ],
                            "size-class": "col-6",
                            title: _vm.$t(
                              "application-form.annual-property-taxes"
                            ),
                            "container-class": "dollar-prepend w-100",
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              name: "property-taxes",
                              placeholder: "0",
                              "class-name": "fe-num-field dollar",
                              tabindex: "400",
                              label: _vm.$t(
                                "application-form.annual-property-taxes"
                              ),
                            },
                            model: {
                              value: _vm.propertyTaxes,
                              callback: function ($$v) {
                                _vm.propertyTaxes = $$v
                              },
                              expression: "propertyTaxes",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.taxResponsible,
                            ],
                            "size-class": "col-12 radio-field",
                            title: _vm.$t(
                              "application-form.who-making-tax-payments"
                            ),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("radio-section", {
                            attrs: {
                              name: "tax-responsible",
                              options: _vm.taxResponsibleOptions,
                              tabindex: "400",
                            },
                            model: {
                              value: _vm.taxResponsible,
                              callback: function ($$v) {
                                _vm.taxResponsible = $$v
                              },
                              expression: "taxResponsible",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-xxl-6 application-card-wrapper" },
            [
              _c(
                "div",
                {
                  staticClass: "card pb-0 application-card h-100",
                  attrs: { id: "occupancy" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header px-5",
                      attrs: { id: _vm._f("hashId")("property[occupancy]") },
                    },
                    [
                      _c("div", { staticClass: "row align-items-center" }, [
                        _c("div", { staticClass: "col-11" }, [
                          _c("h2", { staticClass: "section-separator-title" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("application-form.occupancy")) +
                                "\n                  "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.editVisibility
                          ? _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("multiple-visibility-button", {
                                  attrs: {
                                    "visibility-paths":
                                      _vm.PagesVisibilityMap[
                                        "property-occupancy"
                                      ],
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body px-5" }, [
                    _c(
                      "div",
                      { staticClass: "row align-items-start" },
                      [
                        _c(
                          "field",
                          {
                            attrs: {
                              "edit-visibility": _vm.editVisibility,
                              "visibility-paths": [
                                _vm.visibilityPaths.occupancy,
                              ],
                              "size-class": "col-sm-4 col-12",
                              title: _vm.$t(
                                "application-form.property-occupancy-type"
                              ),
                            },
                            on: { "toggle-visibility": _vm.handleVisibility },
                          },
                          [
                            _c("select-section", {
                              attrs: {
                                name: "occupancy",
                                options: _vm.occupancyTypeOptions,
                                tabindex: "500",
                              },
                              model: {
                                value: _vm.occupancy,
                                callback: function ($$v) {
                                  _vm.occupancy = $$v
                                },
                                expression: "occupancy",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isRentalType
                          ? _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.rentalProperty,
                                    _vm.visibilityPaths.monthlyIncome,
                                  ],
                                  "size-class": "col-sm-4 radio-field",
                                  title: _vm.$t(
                                    "application-form.is-income-property"
                                  ),
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("radio-section", {
                                  attrs: {
                                    name: "rental-property",
                                    options: _vm.binaryTrueShowsOptions,
                                    tabindex: "500",
                                  },
                                  model: {
                                    value: _vm.rentalProperty,
                                    callback: function ($$v) {
                                      _vm.rentalProperty = $$v
                                    },
                                    expression: "rentalProperty",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "transition",
                          { attrs: { name: "slide-fade" } },
                          [
                            _vm.editVisibility ||
                            _vm.visibilityToggle(
                              _vm.currentApplication,
                              _vm._visibilityDataContext,
                              "['property']['details']['rental-property']",
                              _vm.binaryTrueShowsOptions,
                              "monthlyIncome"
                            )
                              ? _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.monthlyIncome,
                                      ],
                                      "depends-upon": [
                                        _vm.visibilityPaths.rentalProperty,
                                      ],
                                      "size-class": "col-sm-4",
                                      title: _vm.$t(
                                        "application-form.monthly-income"
                                      ),
                                      "container-class": "dollar-prepend",
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("text-section", {
                                      attrs: {
                                        name: "monthly-income",
                                        placeholder: "0",
                                        "class-name": "dollar fe-num-field",
                                        tabindex: "500",
                                        label: _vm.$t(
                                          "application-form.monthly-income"
                                        ),
                                      },
                                      model: {
                                        value: _vm.monthlyIncome,
                                        callback: function ($$v) {
                                          _vm.monthlyIncome = $$v
                                        },
                                        expression: "monthlyIncome",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-xxl-6" }, [
            _c(
              "div",
              {
                staticClass: "card pb-0 application-card",
                attrs: { id: "property-fees" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header px-5",
                    attrs: { id: _vm._f("hashId")("property[fees]") },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "row align-items-center" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-auto col-12 d-flex justify-content-between align-items-center",
                          },
                          [
                            _c(
                              "h2",
                              { staticClass: "section-separator-title" },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t("application-form.property-fees")
                                    ) +
                                    "\n                  "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "field",
                          {
                            staticClass: "text-lg-right mt-lg-0 mt-2",
                            attrs: {
                              "edit-visibility": _vm.editVisibility,
                              "hide-eye": true,
                              "visibility-paths": [
                                _vm.visibilityPaths.includeInTds,
                              ],
                              "size-class": "col",
                            },
                            on: { "toggle-visibility": _vm.handleVisibility },
                          },
                          [
                            _c("checkbox-section", {
                              attrs: {
                                name: "include-in-tds",
                                label: _vm.$t(
                                  "application-form.include-tds-calculation"
                                ),
                                "container-class": "mb-0",
                                "multi-line": false,
                                tabindex: "600",
                              },
                              model: {
                                value: _vm.includeInTds,
                                callback: function ($$v) {
                                  _vm.includeInTds = $$v
                                },
                                expression: "includeInTds",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.editVisibility
                          ? _c(
                              "div",
                              { staticClass: "col-1" },
                              [
                                _c("multiple-visibility-button", {
                                  attrs: {
                                    "visibility-paths":
                                      _vm.PagesVisibilityMap["property-fees"],
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-body px-5" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-lg-12 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.maintenanceFees,
                                ],
                                "size-class": "col-sm-6 col-12",
                                title: _vm.$t(
                                  "application-form.maintenance-fees-monthly"
                                ),
                                "container-class": "dollar-prepend w-100",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "maintenance-fees",
                                  placeholder: "0",
                                  "class-name": "fe-num-field dollar",
                                  tabindex: "600",
                                  label: _vm.$t(
                                    "application-form.maintenance-fees-monthly"
                                  ),
                                },
                                model: {
                                  value: _vm.maintenanceFees,
                                  callback: function ($$v) {
                                    _vm.maintenanceFees = $$v
                                  },
                                  expression: "maintenanceFees",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.percOfTotalMaintFees,
                                ],
                                "size-class": "col-sm-6 col-12",
                                title: _vm.$t(
                                  "application-form.condo-fee-allocation-percentage"
                                ),
                                "container-class": "perc-append w-100",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "perc-of-total-maint-fees",
                                  placeholder: "0",
                                  "class-name": "percentage-format",
                                  tabindex: "600",
                                  label: _vm.$t(
                                    "application-form.condo-fee-allocation-percentage"
                                  ),
                                },
                                model: {
                                  value: _vm.percOfTotalMaintFees,
                                  callback: function ($$v) {
                                    _vm.percOfTotalMaintFees = $$v
                                  },
                                  expression: "percOfTotalMaintFees",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.feesIncludeHeat,
                                ],
                                "size-class": "col-sm-6 col-12 radio-field",
                                title: _vm.$t(
                                  "application-form.is-heat-included"
                                ),
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("radio-section", {
                                attrs: {
                                  name: "fees-include-heat",
                                  options: _vm.binaryFalseShowsOptions,
                                  tabindex: "600",
                                },
                                model: {
                                  value: _vm.feesIncludeHeat,
                                  callback: function ($$v) {
                                    _vm.feesIncludeHeat = $$v
                                  },
                                  expression: "feesIncludeHeat",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "transition",
                            { attrs: { name: "slide-fade" } },
                            [
                              _vm.editVisibility ||
                              _vm.visibilityToggle(
                                _vm.currentApplication,
                                _vm._visibilityDataContext,
                                "['property']['costs']['fees-include-heat']",
                                _vm.binaryFalseShowsOptions,
                                "heating"
                              )
                                ? _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.heating,
                                        ],
                                        "depends-upon": [
                                          _vm.visibilityPaths.feesIncludeHeat,
                                        ],
                                        "size-class": "col-sm-6 col-12",
                                        title: _vm.$t(
                                          "application-form.heat-fees-monthly"
                                        ),
                                        "container-class":
                                          "dollar-prepend w-100",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          name: "heating",
                                          placeholder: "0",
                                          "class-name": "fe-num-field dollar",
                                          tabindex: "600",
                                          label: _vm.$t(
                                            "application-form.heat-fees-monthly"
                                          ),
                                        },
                                        model: {
                                          value: _vm.heating,
                                          callback: function ($$v) {
                                            _vm.heating = $$v
                                          },
                                          expression: "heating",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-lg-12 col-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-12 col-12" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "field",
                                {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "size-class": "col-sm-6 col-12",
                                    title: _vm.$t(
                                      "application-form.hydro-fees-monthly"
                                    ),
                                    "container-class": "dollar-prepend w-100",
                                    "visibility-paths": [
                                      _vm.visibilityPaths.hydro,
                                    ],
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                },
                                [
                                  _c("text-section", {
                                    attrs: {
                                      name: "hydro",
                                      placeholder: "0",
                                      "class-name": "fe-num-field dollar",
                                      tabindex: "600",
                                      label: _vm.$t(
                                        "application-form.hydro-fees-monthly"
                                      ),
                                    },
                                    model: {
                                      value: _vm.hydro,
                                      callback: function ($$v) {
                                        _vm.hydro = $$v
                                      },
                                      expression: "hydro",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "field",
                                {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "visibility-paths": [
                                      _vm.visibilityPaths.repairs,
                                    ],
                                    "size-class": "col-sm-6 col-12",
                                    title: _vm.$t(
                                      "application-form.repairs-monthly"
                                    ),
                                    "container-class": "dollar-prepend w-100",
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                },
                                [
                                  _c("text-section", {
                                    attrs: {
                                      name: "repairs",
                                      placeholder: "0",
                                      "class-name": "fe-num-field dollar",
                                      tabindex: "600",
                                      label: _vm.$t(
                                        "application-form.repairs-monthly"
                                      ),
                                    },
                                    model: {
                                      value: _vm.repairs,
                                      callback: function ($$v) {
                                        _vm.repairs = $$v
                                      },
                                      expression: "repairs",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "field",
                                {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "visibility-paths": [
                                      _vm.visibilityPaths.insurance,
                                    ],
                                    "size-class": "col-sm-6 col-12",
                                    title: _vm.$t(
                                      "application-form.insurance-fees-monthly"
                                    ),
                                    "container-class": "dollar-prepend w-100",
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                },
                                [
                                  _c("text-section", {
                                    attrs: {
                                      name: "insurance",
                                      placeholder: "0",
                                      "class-name": "fe-num-field dollar",
                                      tabindex: "600",
                                      label: _vm.$t(
                                        "application-form.insurance-fees-monthly"
                                      ),
                                    },
                                    model: {
                                      value: _vm.insurance,
                                      callback: function ($$v) {
                                        _vm.insurance = $$v
                                      },
                                      expression: "insurance",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "field",
                                {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "visibility-paths": [
                                      _vm.visibilityPaths.interest,
                                    ],
                                    "size-class": "col-sm-6 col-12",
                                    title: _vm.$t(
                                      "application-form.interest-fees-monthly"
                                    ),
                                    "container-class": "dollar-prepend w-100",
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                },
                                [
                                  _c("text-section", {
                                    attrs: {
                                      name: "interest",
                                      placeholder: "0",
                                      "class-name": "fe-num-field dollar",
                                      tabindex: "600",
                                      label: _vm.$t(
                                        "application-form.interest-fees-monthly"
                                      ),
                                    },
                                    model: {
                                      value: _vm.interest,
                                      callback: function ($$v) {
                                        _vm.interest = $$v
                                      },
                                      expression: "interest",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "field",
                                {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "visibility-paths": [
                                      _vm.visibilityPaths.management,
                                    ],
                                    "size-class": "col-sm-6 col-12",
                                    title: _vm.$t(
                                      "application-form.management-fees-monthly"
                                    ),
                                    "container-class": "dollar-prepend w-100",
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                },
                                [
                                  _c("text-section", {
                                    attrs: {
                                      name: "management",
                                      placeholder: "0",
                                      "class-name": "fe-num-field dollar",
                                      tabindex: "600",
                                      label: _vm.$t(
                                        "application-form.management-fees-monthly"
                                      ),
                                    },
                                    model: {
                                      value: _vm.management,
                                      callback: function ($$v) {
                                        _vm.management = $$v
                                      },
                                      expression: "management",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "field",
                                {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "visibility-paths": [
                                      _vm.visibilityPaths.others,
                                    ],
                                    "size-class": "col-sm-6 col-12",
                                    title: _vm.$t(
                                      "application-form.other-fees-monthly"
                                    ),
                                    "container-class": "dollar-prepend w-100",
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                },
                                [
                                  _c("text-section", {
                                    attrs: {
                                      name: "others",
                                      placeholder: "0",
                                      "class-name": "fe-num-field dollar",
                                      tabindex: "600",
                                      label: _vm.$t(
                                        "application-form.other-fees-monthly"
                                      ),
                                    },
                                    model: {
                                      value: _vm.others,
                                      callback: function ($$v) {
                                        _vm.others = $$v
                                      },
                                      expression: "others",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "field",
                                {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "visibility-paths": [
                                      _vm.visibilityPaths.rentalIncomeOptions,
                                      _vm.visibilityPaths
                                        .rentalIncomeOptionsPercent,
                                    ],
                                    "size-class": "col-sm-6 col-12",
                                    title: _vm.$t(
                                      "application-form.rental-income-offset"
                                    ),
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                },
                                [
                                  _c("select-section", {
                                    attrs: {
                                      name: "rental-income-options",
                                      options: _vm.rentalIncomeSelectOptions,
                                      tabindex: "600",
                                    },
                                    model: {
                                      value: _vm.rentalIncomeOptions,
                                      callback: function ($$v) {
                                        _vm.rentalIncomeOptions = $$v
                                      },
                                      expression: "rentalIncomeOptions",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "transition",
                                { attrs: { name: "slide-fade" } },
                                [
                                  _vm.editVisibility ||
                                  _vm.visibilityToggle(
                                    _vm.currentApplication,
                                    _vm._visibilityDataContext,
                                    "['property']['costs']['rental-income-options']",
                                    _vm.rentalIncomeSelectOptions,
                                    "rentalIncomeOptionsPercent"
                                  )
                                    ? _c(
                                        "field",
                                        {
                                          attrs: {
                                            "edit-visibility":
                                              _vm.editVisibility,
                                            "visibility-paths": [
                                              _vm.visibilityPaths
                                                .rentalIncomeOptionsPercent,
                                            ],
                                            "depends-upon": [
                                              _vm.visibilityPaths
                                                .rentalIncomeOptions,
                                            ],
                                            "size-class": "col-md-6 col-12",
                                            title: _vm.$t(
                                              "application-form.rental-income-offset-percent"
                                            ),
                                            "container-class":
                                              "perc-append w-100",
                                          },
                                          on: {
                                            "toggle-visibility":
                                              _vm.handleVisibility,
                                          },
                                        },
                                        [
                                          _c("text-section", {
                                            attrs: {
                                              "class-name": "percentage-format",
                                              name: "rental-income-options-percent",
                                              placeholder: "0",
                                              decimals: 0,
                                              "max-length": 3,
                                              max: "100",
                                              "show-max-length-label": false,
                                              tabindex: "600",
                                              label: _vm.$t(
                                                "application-form.rental-income-offset-percent"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.rentalIncomeOptionsPercent,
                                              callback: function ($$v) {
                                                _vm.rentalIncomeOptionsPercent =
                                                  $$v
                                              },
                                              expression:
                                                "rentalIncomeOptionsPercent",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-xxl-6 application-card-wrapper" },
            [
              _c(
                "div",
                {
                  staticClass: "card pb-0 application-card h-100",
                  attrs: { id: "property-value" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header px-5",
                      attrs: { id: _vm._f("hashId")("property[value]") },
                    },
                    [
                      _c("div", { staticClass: "row align-items-center" }, [
                        _c("div", { staticClass: "col-11" }, [
                          _c("h2", { staticClass: "section-separator-title" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t("application-form.property-value")
                                ) +
                                "\n                  "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.editVisibility
                          ? _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("multiple-visibility-button", {
                                  attrs: {
                                    "visibility-paths":
                                      _vm.PagesVisibilityMap["property-value"],
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body px-5" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-6 col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.purchasePrice,
                                  ],
                                  "size-class": "col-12",
                                  title: _vm.$t(
                                    "application-form.purchase-price"
                                  ),
                                  "container-class": "dollar-prepend w-100",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    name: "purchase-price",
                                    "class-name": "dollar fe-num-field",
                                    tabindex: "700",
                                    label: _vm.$t(
                                      "application-form.purchase-price"
                                    ),
                                  },
                                  on: {
                                    change: _vm.setDefaultPropertyValueIndex,
                                  },
                                  model: {
                                    value: _vm.purchasePrice,
                                    callback: function ($$v) {
                                      _vm.purchasePrice = $$v
                                    },
                                    expression: "purchasePrice",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.appraisedValue,
                                  ],
                                  "size-class": "col-12",
                                  title: _vm.$t(
                                    "application-form.appraised-value"
                                  ),
                                  "container-class": "dollar-prepend w-100",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    name: "appraised-value",
                                    "class-name": "dollar fe-num-field",
                                    tabindex: "700",
                                    label: _vm.$t(
                                      "application-form.appraised-value"
                                    ),
                                  },
                                  on: {
                                    change: _vm.setDefaultPropertyValueIndex,
                                  },
                                  model: {
                                    value: _vm.appraisedValue,
                                    callback: function ($$v) {
                                      _vm.appraisedValue = $$v
                                    },
                                    expression: "appraisedValue",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.estimatedValue,
                                  ],
                                  "size-class": "col-12",
                                  title: _vm.$t(
                                    "application-form.estimated-value"
                                  ),
                                  "container-class": "dollar-prepend w-100",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    name: "estimated-value",
                                    "class-name": "dollar fe-num-field",
                                    tabindex: "700",
                                    label: _vm.$t(
                                      "application-form.estimated-value"
                                    ),
                                  },
                                  on: {
                                    change: _vm.setDefaultPropertyValueIndex,
                                  },
                                  model: {
                                    value: _vm.estimatedValue,
                                    callback: function ($$v) {
                                      _vm.estimatedValue = $$v
                                    },
                                    expression: "estimatedValue",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.appraisalDate,
                                  ],
                                  "size-class": "col-12",
                                  title: _vm.$t(
                                    "application-form.appraisal-date"
                                  ),
                                  "container-class": "w-100",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("date-section", {
                                  attrs: {
                                    name: "appraisal-date",
                                    placeholder: "YYYY-MM-DD",
                                    "class-name": "date-format",
                                    tabindex: "700",
                                    label: _vm.$t(
                                      "application-form.appraisal-date"
                                    ),
                                  },
                                  on: { change: _vm.handleSave },
                                  model: {
                                    value: _vm.appraisalDate,
                                    callback: function ($$v) {
                                      _vm.appraisalDate = $$v
                                    },
                                    expression: "appraisalDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-6 col-12" }, [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "hide-eye": true,
                                  "size-class": "col-12 radio-field",
                                  title: _vm.$t(
                                    "application-form.property-valuation-question"
                                  ),
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("radio-section", {
                                  attrs: {
                                    name: "property-value-index",
                                    options: _vm.propertyValueIndexOptions,
                                    tabindex: "700",
                                    "emit-change-on-click": false,
                                  },
                                  model: {
                                    value: _vm.propertyValueIndex,
                                    callback: function ($$v) {
                                      _vm.propertyValueIndex = $$v
                                    },
                                    expression: "propertyValueIndex",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.allowForExistingMortgages
        ? _c(
            "div",
            {
              staticClass: "card pb-0 application-card",
              attrs: { id: "existing-mortgages" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "card-header px-5",
                  attrs: {
                    id: _vm._f("hashId")("property[existing-mortgages]"),
                  },
                },
                [
                  _c("div", { staticClass: "row justify-content-between" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("application-card-header", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "section-separator-title",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$tc(
                                                "application-form.existing-mortgage",
                                                2
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "title-right",
                                fn: function () {
                                  return [
                                    _c("inline-prompt", {
                                      staticClass: "bold text-gray clickable",
                                      attrs: {
                                        "confirmation-text": _vm.$t(
                                          "application.messages.allExistingMortgagesWillBeDeleted"
                                        ),
                                      },
                                      on: {
                                        accept:
                                          _vm.handleDeleteAllExistingMortgages,
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3406886046
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body px-5" },
                [
                  _vm.allowForExistingMortgages
                    ? _c(
                        "group-set",
                        {
                          attrs: {
                            "group-name": _vm.$tc(
                              "application-form.existing-mortgage",
                              1
                            ),
                            multi: !_vm.editVisibility,
                            source:
                              _vm.currentApplication["property"][
                                "existing-mortgages"
                              ],
                            path: "property['existing-mortgages']",
                            tabindex: "800",
                          },
                          on: { duplicate: _vm.handleDuplicate },
                        },
                        _vm._l(
                          _vm.existingMortgages,
                          function (mortgage, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "row mb-5",
                                attrs: {
                                  id: _vm._f("hashId")(
                                    "property[existing-mortgages][" +
                                      index +
                                      "]"
                                  ),
                                  "group-index": index,
                                },
                              },
                              [
                                _c("div", { staticClass: "col-12" }, [
                                  _vm.currentApplication["property"][
                                    "existing-mortgages"
                                  ].length > 1
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "bold mb-4 text-secondary",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.ordinalIndex(index)) +
                                              "\n                " +
                                              _vm._s(
                                                _vm.$tc(
                                                  "application-form.existing-mortgage",
                                                  1
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                          index > 0
                                            ? _c("span", [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "text-danger ml-2 remove-field clickable",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleRemove(
                                                          index,
                                                          "['property']['existing-mortgages']"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-trash",
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[mortgage-type]",
                                      ],
                                      "size-class": "col-lg-4 col-md-6 col-12",
                                      title: _vm.$t(
                                        "application-form.mortgage-type"
                                      ),
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("select-section", {
                                      attrs: {
                                        name: "mortgage-type",
                                        options: _vm.mortgageTypeOptions,
                                        tabindex: "800",
                                      },
                                      on: {
                                        change:
                                          _vm.applyDefaultValuesOnMortgageTypeChange,
                                      },
                                      model: {
                                        value: mortgage["mortgage-type"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            mortgage,
                                            "mortgage-type",
                                            $$v
                                          )
                                        },
                                        expression: "mortgage['mortgage-type']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[balance-remaining]",
                                      ],
                                      "size-class": "col-lg-4 col-md-6 col-12",
                                      title: _vm.$t(
                                        "application-form.balance-remaining"
                                      ),
                                      "container-class": "dollar-prepend",
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("text-section", {
                                      attrs: {
                                        name: "balance-remaining",
                                        placeholder: "0",
                                        "class-name": "dollar fe-num-field",
                                        tabindex: "800",
                                        label: _vm.$t(
                                          "application-form.balance-remaining"
                                        ),
                                      },
                                      model: {
                                        value: mortgage["balance-remaining"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            mortgage,
                                            "balance-remaining",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mortgage['balance-remaining']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[payment-amount]",
                                      ],
                                      "size-class": "col-lg-4 col-md-6 col-12",
                                      title: _vm.$t(
                                        "application-form.payment-amount"
                                      ),
                                      "container-class": "dollar-prepend",
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("text-section", {
                                      attrs: {
                                        name: "payment-amount",
                                        placeholder: "0",
                                        "class-name": "dollar fe-num-field",
                                        tabindex: "800",
                                        label: _vm.$t(
                                          "application-form.payment-amount"
                                        ),
                                      },
                                      model: {
                                        value: mortgage["payment-amount"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            mortgage,
                                            "payment-amount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mortgage['payment-amount']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[frequency]",
                                      ],
                                      "size-class": "col-lg-4 col-md-6 col-12",
                                      title: _vm.$t(
                                        "application-form.payment-frequency"
                                      ),
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("select-section", {
                                      attrs: {
                                        name: "frequency",
                                        options: _vm.frequencyOptions,
                                        tabindex: "800",
                                      },
                                      model: {
                                        value: mortgage["frequency"],
                                        callback: function ($$v) {
                                          _vm.$set(mortgage, "frequency", $$v)
                                        },
                                        expression: "mortgage['frequency']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[maturity-date]",
                                      ],
                                      "size-class": "col-lg-4 col-md-6 col-12",
                                      title: _vm.$t(
                                        "application-form.maturity-date"
                                      ),
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("date-section", {
                                      attrs: {
                                        name: "maturity-date",
                                        placeholder: "YYYY-MM-DD",
                                        "class-name": "date-format",
                                        tabindex: "800",
                                        label: _vm.$t(
                                          "application-form.maturity-date"
                                        ),
                                      },
                                      on: { change: _vm.handleSave },
                                      model: {
                                        value: mortgage["maturity-date"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            mortgage,
                                            "maturity-date",
                                            $$v
                                          )
                                        },
                                        expression: "mortgage['maturity-date']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[rate-type]",
                                      ],
                                      "size-class": "col-lg-4 col-md-6 col-12",
                                      title: _vm.$t(
                                        "application-form.rate-type"
                                      ),
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("select-section", {
                                      attrs: {
                                        name: "rate-type",
                                        options: _vm.rateTypeOptions,
                                        tabindex: "800",
                                      },
                                      model: {
                                        value: mortgage["rate-type"],
                                        callback: function ($$v) {
                                          _vm.$set(mortgage, "rate-type", $$v)
                                        },
                                        expression: "mortgage['rate-type']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[term-type]",
                                      ],
                                      "size-class": "col-lg-4 col-md-6 col-12",
                                      title: _vm.$t(
                                        "application-form.term-type"
                                      ),
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("select-section", {
                                      attrs: {
                                        name: "term-type",
                                        options: _vm.termTypeOptions,
                                        tabindex: "800",
                                      },
                                      model: {
                                        value: mortgage["term-type"],
                                        callback: function ($$v) {
                                          _vm.$set(mortgage, "term-type", $$v)
                                        },
                                        expression: "mortgage['term-type']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[lender]",
                                      ],
                                      "size-class": "col-lg-4 col-md-6 col-12",
                                      title: _vm.$t("application-form.lender"),
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("text-section", {
                                      attrs: {
                                        name: "lender",
                                        "max-length": "80",
                                        tabindex: "800",
                                        label: _vm.$t(
                                          "application-form.lender"
                                        ),
                                      },
                                      model: {
                                        value: mortgage["lender"],
                                        callback: function ($$v) {
                                          _vm.$set(mortgage, "lender", $$v)
                                        },
                                        expression: "mortgage['lender']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[loan-type]",
                                      ],
                                      "size-class": "col-lg-4 col-md-6 col-12",
                                      title: _vm.$t(
                                        "application-form.loan-type"
                                      ),
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("select-section", {
                                      attrs: {
                                        name: "loan-type",
                                        options: _vm.loanTypeOptions,
                                        tabindex: "800",
                                      },
                                      model: {
                                        value: mortgage["loan-type"],
                                        callback: function ($$v) {
                                          _vm.$set(mortgage, "loan-type", $$v)
                                        },
                                        expression: "mortgage['loan-type']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[payoff]",
                                      ],
                                      "size-class": "col-lg-4 col-md-6 col-12",
                                      title: _vm.$t("application-form.payoff"),
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("select-section", {
                                      attrs: {
                                        name: "payoff",
                                        options: _vm.payoffOptions,
                                        tabindex: "800",
                                      },
                                      model: {
                                        value: mortgage["payoff"],
                                        callback: function ($$v) {
                                          _vm.$set(mortgage, "payoff", $$v)
                                        },
                                        expression: "mortgage['payoff']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[orig-amount]",
                                      ],
                                      "size-class": "col-lg-2 col-md-6 col-12",
                                      "long-title": true,
                                      title: _vm.$t(
                                        "application-form.original-mortgage-amount"
                                      ),
                                      "container-class": "dollar-prepend",
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("text-section", {
                                      attrs: {
                                        name: "orig-amount",
                                        placeholder: "0",
                                        "class-name": "dollar fe-num-field",
                                        tabindex: "800",
                                        label: _vm.$t(
                                          "application-form.original-mortgage-amount"
                                        ),
                                      },
                                      model: {
                                        value: mortgage["orig-amount"],
                                        callback: function ($$v) {
                                          _vm.$set(mortgage, "orig-amount", $$v)
                                        },
                                        expression: "mortgage['orig-amount']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[interest-rate]",
                                      ],
                                      "size-class": "col-lg-2 col-md-6 col-12",
                                      title: _vm.$t(
                                        "application-form.interest-rate"
                                      ),
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("text-section", {
                                      attrs: {
                                        name: "interest-rate",
                                        placeholder: "0.00",
                                        "class-name": "rate",
                                        tabindex: "800",
                                        label: _vm.$t(
                                          "application-form.interest-rate"
                                        ),
                                      },
                                      model: {
                                        value: mortgage["interest-rate"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            mortgage,
                                            "interest-rate",
                                            $$v
                                          )
                                        },
                                        expression: "mortgage['interest-rate']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[current-mortgage-number]",
                                      ],
                                      "size-class": "col-lg-4 col-md-6 col-12",
                                      title: _vm.$t(
                                        "application-form.mortgage-number"
                                      ),
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("text-section", {
                                      attrs: {
                                        name: "current-mortgage-number",
                                        "max-length": "15",
                                        tabindex: "800",
                                        label: _vm.$t(
                                          "application-form.mortgage-number"
                                        ),
                                      },
                                      model: {
                                        value:
                                          mortgage["current-mortgage-number"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            mortgage,
                                            "current-mortgage-number",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mortgage['current-mortgage-number']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "row" },
                                    [
                                      _c(
                                        "field",
                                        {
                                          attrs: {
                                            "edit-visibility":
                                              _vm.editVisibility,
                                            "visibility-paths": [
                                              _vm.visibilityPaths
                                                .existingMortgages +
                                                "[blended-amortization]",
                                            ],
                                            "size-class": "col-md-6 col-12",
                                            title: _vm.editVisibility
                                              ? _vm.$t(
                                                  "application-form.blended-amortization"
                                                )
                                              : "",
                                          },
                                          on: {
                                            "toggle-visibility":
                                              _vm.handleVisibility,
                                          },
                                        },
                                        [
                                          _c("checkbox-section", {
                                            attrs: {
                                              name: "blended-amortization",
                                              label: _vm.$t(
                                                "application-form.blended-amortization"
                                              ),
                                              tabindex: "800",
                                              "hidden-label":
                                                _vm.editVisibility,
                                            },
                                            model: {
                                              value:
                                                mortgage[
                                                  "blended-amortization"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  mortgage,
                                                  "blended-amortization",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mortgage['blended-amortization']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "field",
                                        {
                                          attrs: {
                                            "edit-visibility":
                                              _vm.editVisibility,
                                            "visibility-paths": [
                                              _vm.visibilityPaths
                                                .existingMortgages +
                                                "[insured]",
                                              _vm.visibilityPaths
                                                .existingMortgages +
                                                "[insured-account-number]",
                                              _vm.visibilityPaths
                                                .existingMortgages +
                                                "[mortgage-insurance-provider-id]",
                                            ],
                                            "size-class": "col-md-6 col-12",
                                            title: _vm.editVisibility
                                              ? _vm.$t(
                                                  "application-form.insured"
                                                )
                                              : "",
                                          },
                                          on: {
                                            "toggle-visibility":
                                              _vm.handleVisibility,
                                          },
                                        },
                                        [
                                          _c("checkbox-section", {
                                            attrs: {
                                              name: "insured",
                                              label: _vm.$t(
                                                "application-form.insured"
                                              ),
                                              tabindex: "800",
                                              "hidden-label":
                                                _vm.editVisibility,
                                            },
                                            model: {
                                              value: mortgage["insured"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  mortgage,
                                                  "insured",
                                                  $$v
                                                )
                                              },
                                              expression: "mortgage['insured']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "transition",
                                  { attrs: { name: "slide-fade" } },
                                  [
                                    _vm.editVisibility ||
                                    _vm.visibilityToggle(
                                      _vm.currentApplication,
                                      _vm._visibilityDataContext,
                                      "['property']['existing-mortgages'][" +
                                        index +
                                        "]['insured']",
                                      _vm.binaryTrueShowsOptions,
                                      "existingMortgages[" +
                                        index +
                                        "]['insurance-account-number']"
                                    )
                                      ? _c(
                                          "field",
                                          {
                                            attrs: {
                                              "edit-visibility":
                                                _vm.editVisibility,
                                              "visibility-paths": [
                                                _vm.visibilityPaths
                                                  .existingMortgages +
                                                  "[insurance-account-number]",
                                              ],
                                              "depends-upon": [
                                                _vm.visibilityPaths
                                                  .existingMortgages +
                                                  "[insured]",
                                              ],
                                              "size-class": "col-md-6 col-12",
                                              title: _vm.$t(
                                                "application-form.insurance-account-number"
                                              ),
                                            },
                                            on: {
                                              "toggle-visibility":
                                                _vm.handleVisibility,
                                            },
                                          },
                                          [
                                            _c("text-section", {
                                              attrs: {
                                                name: "insurance-account-number",
                                                "max-length": "35",
                                                tabindex: "800",
                                                label: _vm.$t(
                                                  "application-form.insurance-account-number"
                                                ),
                                              },
                                              model: {
                                                value:
                                                  mortgage[
                                                    "insurance-account-number"
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    mortgage,
                                                    "insurance-account-number",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mortgage['insurance-account-number']",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "transition",
                                  { attrs: { name: "slide-fade" } },
                                  [
                                    _vm.editVisibility ||
                                    _vm.visibilityToggle(
                                      _vm.currentApplication,
                                      _vm._visibilityDataContext,
                                      "['property']['existing-mortgages'][" +
                                        index +
                                        "]['insured']",
                                      _vm.binaryTrueShowsOptions,
                                      "existingMortgages[" +
                                        index +
                                        "]['mortgage-insurance-provider-id']"
                                    )
                                      ? _c(
                                          "field",
                                          {
                                            attrs: {
                                              "edit-visibility":
                                                _vm.editVisibility,
                                              "visibility-paths": [
                                                _vm.visibilityPaths
                                                  .existingMortgages +
                                                  "[mortgage-insurance-provider-id]",
                                              ],
                                              "depends-upon": [
                                                _vm.visibilityPaths
                                                  .existingMortgages +
                                                  "[insured]",
                                              ],
                                              "size-class": "col-md-6 col-12",
                                              title: _vm.$t(
                                                "application-form.insurer"
                                              ),
                                            },
                                            on: {
                                              "toggle-visibility":
                                                _vm.handleVisibility,
                                            },
                                          },
                                          [
                                            _c("select-section", {
                                              attrs: {
                                                name: "mortgage-insurance-provider-id",
                                                options:
                                                  _vm.insuranceProviderOptions,
                                                tabindex: "800",
                                              },
                                              model: {
                                                value:
                                                  mortgage[
                                                    "mortgage-insurance-provider-id"
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    mortgage,
                                                    "mortgage-insurance-provider-id",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mortgage['mortgage-insurance-provider-id']",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.existingMortgages +
                                          "[refi-additional-info]",
                                      ],
                                      "size-class": "col-12",
                                      title: _vm.$t(
                                        "application-form.additional-information"
                                      ),
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("text-section", {
                                      attrs: {
                                        name: "refi-additional-info",
                                        "max-length": "512",
                                        tabindex: "800",
                                        label: _vm.$t(
                                          "application-form.additional-information"
                                        ),
                                      },
                                      model: {
                                        value: mortgage["refi-additional-info"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            mortgage,
                                            "refi-additional-info",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mortgage['refi-additional-info']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }